export default __webpack_public_path__ + "static/media/loading.559b5904.svg";